<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>
        <div class="d-flex align-items-center">
            <div class="card flex-fill">
                <b-tabs small card>
                    <b-tab active class="p-2">
                        <template #title>
                            <b-icon icon="calendar-date" variant="primary"></b-icon>
                            <span class="ms-2">Filtrar por fecha de creación</span>
                        </template>
                        <DateFilter @filter="fetchDenunciations" :initialRange="dateRange" :hideClear="true">
                        </DateFilter>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="col-md-2 ms-3 d-flex">
                <div class="align-items-center flex-grow-1">
                    <div class="h-100 d-flex flex-column justify-content-center">
                        <PrintWindow class="w-100 mb-2" tooltip="Imprimir tabla" title="Reporte de Denuncias Karin">
                            <CompanyInformationCard :title="reportTitle" class="mb-3"></CompanyInformationCard>
                            <KarinReportTable :items="items" />
                        </PrintWindow>
                        <KarinReportExcel class="mt-2" :items="items" />
                    </div>
                </div>
            </div>
        </div>

        <KarinReportTable class="m-3" :items="items"></KarinReportTable>
    </div>
</template>

<script>
import DateFilter from '@/components/shared/Filters/Date-filter.vue'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import KarinReportTable from './KarinReport/Karin-report-table.vue'
import PrintWindow from '@/components/shared/Print-window.vue'
import { mapActions } from 'vuex'
import { addDays, formatDateInput, formatApproval} from '@/plugins/complianceScripts/index.js'
import CompanyInformationCard from '@/components/shared/Company-information-card.vue'
import KarinReportExcel from './KarinReport/Karin-report-excel.vue'

export default {
    name: 'KarinReport',

    components: {
        DateFilter,
        AlertDismiss,
        KarinReportTable,
        PrintWindow,
        CompanyInformationCard,
        KarinReportExcel
    },

    data() {
        const today = new Date()
        const sevenDaysAgo = addDays(today, -7)

        return {
            dateRange: {
                startDate: `${formatDateInput(sevenDaysAgo)}T00:00:00.000Z`,
                endDate: `${formatDateInput(today)}T23:59:59.999Z`
            },
            items: []
        }
    },

    computed: {
        reportTitle() {
            return `Denuncias Ley Karin: (${this.formatDateOnly(this.dateRange.startDate)} - ${this.formatDateOnly(this.dateRange.endDate)})`;
        },
    },

    async mounted() {
        await this.fetchDenunciations(this.dateRange)
    },

    methods: {
        ...mapActions(["allKarinDenunciationByDate", "allCommentsKarinDenunciation"]),

        formatDateOnly(date) {
            if (!date) return '';
            const fechaHora = new Date(date);
            return fechaHora.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        },

        formatDenounced(person){
            return `${person.name} - ${person.mail} - ${person.rut} - ${person.position}`;
        },

        async fetchDenunciations(range) {
            this.dateRange = range;

            const result = await this.allKarinDenunciationByDate({
                initDate: range.startDate,
                finalDate: range.endDate,
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.items = await Promise.all(result.data.map(async (item) => {
                const commentsResult = await this.allCommentsKarinDenunciation({ denunciationId: item.id });
                const comments = commentsResult.isError ? [] : commentsResult.data;

                const user = item.affected ? item.affected : item.accuser

                return {
                    accuserNombre: user.name,
                    accuserCorreo: user.mail,
                    accuserRut: user.rut,
                    id: item.id,
                    preventive: item.preventive,
                    denunciationType: item.denunciationType.name,
                    descripcion: item.descripcion,
                    creationDate: item.creationDate,
                    document: item.document,
                    approval: formatApproval(item.approval),
                    approvalItem: item.approval,
                    accuser: item.accuser,
                    reported: item.peopleReported.map(this.formatDenounced),
                    external: item.externallink,
                    affected: item.affected,
                    comments: comments
                };
            }));
        }
    }
}
</script>

<style></style>